<template>
  <v-row align="center" justify="center" class="text-row">
    <v-col cols="10" md="6" class="p-relative">
      <div v-if="chapterTitle">
        <span><span class="line"/> <translate>Chapter</translate> {{chapterID}}</span>
        <h2 :class="[chapterSubtitle ? 'mb-0' : 'mb-6']">{{chapterTitle}}</h2>
        <p v-if="chapterSubtitle">{{chapterSubtitle}}</p>
      </div>
      <MarkdownBlock :inline="true" :linkify="true" tag="h3" :text="text" />
    </v-col>
  </v-row>
</template>

<script>
import { MarkdownBlock } from '@monogrid/vue-lib'

export default {
  name: 'TextRow',

  components: {
    MarkdownBlock
  },

  props: {
    text: {
      type: String,
      required: true
    },
    chapterID: {
      type: Number,
      required: false
    },
    chapterTitle: {
      type: String,
      required: false
    },
    chapterSubtitle: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped lang="scss">

.text-row {
  margin: 0 auto;
  height: 100vh;
  opacity: 1;
  transition: opacity 0.3s ease-out;

  &.row--visible {
    opacity: 1;
  }
}

.p-relative {
  position: relative;
}

h3 {
  font-family: Lora;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: $c-light-grey;
  position: relative;
  z-index: 1;

  @include breakpoint('sm-and-down') {
    font-size: 14px;
  }
}

span.line {
  border-top: 1px solid #fff;
  width: 70px;
  height: 5px;
  display: inline-block;
  margin-right: 10px;
}

.quote-icon {
  position: absolute;

  z-index: 0;

  left: -70px;
  top: -20px;

  width: 70px;
  height: auto;

  @include breakpoint('sm-and-down') {
    width: 30px;
    left: -25px;
    top: 0;
  }

  path {
    fill: $c-white;
  }
}
</style>
